import { render, staticRenderFns } from "./ValorTotalContratos.vue?vue&type=template&id=06c709d4"
import script from "./ValorTotalContratos.vue?vue&type=script&lang=js"
export * from "./ValorTotalContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports